import { createApp, VueElement } from 'vue'
import App from './App.vue'
import router from './router'


import "./assets/css/globalConfig.css"
// import {navigationIndex} from "@/utils/config.js"

const app = createApp(App)
app.use(router).mount('#app')


